
export const toBlob = (uint8Array: Uint8Array, type: string) => new Blob([uint8Array], { type });
